import React from 'react';
import { repairCategories, phoneImage } from '../../data/mock';
import { Check } from 'lucide-react';

export default function Repairs() {
  return (
    <section id="riparazioni" className="py-24 lg:py-32 bg-slate-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(14,165,233,0.15),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_10%_80%,rgba(8,145,178,0.12),transparent_55%)]" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-sky-400 text-xs font-bold uppercase tracking-[0.2em]">Le nostre riparazioni</div>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-white tracking-tight">Ripariamo praticamente tutto</h2>
          <p className="mt-4 text-slate-300 text-lg">Specializzati in ogni categoria di prodotti elettronici, dai dispositivi consumer fino ai server aziendali.</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {repairCategories.map((c) => {
            const Icon = c.icon;
            return (
              <div key={c.title} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-7 hover:bg-white/10 hover:border-sky-400/40 transition-all duration-300">
                <div className="w-12 h-12 rounded-xl bg-sky-500/20 text-sky-300 flex items-center justify-center">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="mt-5 text-xl font-bold text-white">{c.title}</h3>
                <ul className="mt-4 space-y-2">
                  {c.items.map((it) => (
                    <li key={it} className="flex items-center gap-2 text-slate-300 text-sm">
                      <Check className="w-4 h-4 text-sky-400 flex-shrink-0" />{it}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="mt-20 grid lg:grid-cols-2 gap-10 items-center bg-gradient-to-br from-sky-600 to-blue-700 rounded-3xl p-10 lg:p-14">
          <div>
            <h3 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight">Garanzia, trasparenza, preventivi chiari</h3>
            <p className="mt-4 text-sky-50 text-lg leading-relaxed">Ogni riparazione è coperta da 3 mesi di garanzia. Comunichiamo sempre il massimo di spesa in fase di accettazione: se serve di più, ti chiediamo conferma. Nessuna sorpresa.</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="px-4 py-2 rounded-full bg-white/15 text-white text-sm font-medium">Diagnosi gratuita</span>
              <span className="px-4 py-2 rounded-full bg-white/15 text-white text-sm font-medium">Pezzi originali</span>
              <span className="px-4 py-2 rounded-full bg-white/15 text-white text-sm font-medium">Fattura elettronica</span>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <img src={phoneImage} alt="Riparazione smartphone" className="w-full h-72 object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
}
